import styled from 'styled-components/macro';
import BaseIcon from '../layout/Icon';

export default styled(BaseIcon)`
  line-height: 15px;
`;
